import jwtDecode from 'jwt-decode';
import fp from 'lodash/fp';
import { push } from 'react-router-redux';
import { createActions } from 'redux-actions';
import { put } from 'redux-saga/effects';
import { routes } from '../../../../constants';

const actions = createActions({
  SESSION: {
    AUTHENTICATE: (idToken, mockUserId, invitationToken, customRedirect, noRedirect) => ({ idToken, mockUserId, invitationToken, customRedirect, noRedirect })
  }
})

export function* authenticate(action) {
  // redirect when authenticated

  const { invitationToken, customRedirect, noRedirect } = action.payload;

  if (invitationToken && invitationToken !== 'undefined') {
    yield put(push({ pathname: routes.app.confirmAcceptInvitation, search: `?invitationToken=${invitationToken}` }));
  }
  else if (customRedirect && customRedirect !== 'undefined') {

    var fullPath = Buffer.from(customRedirect, 'base64').toString('ascii');
    var path = fullPath.split('?')[0] || fullPath;
    var search = fullPath.split('?')[1] || '';
    yield put(push({ pathname: path, search: search }));
  }
  else {
    if (!noRedirect) {
      yield put(push({ pathname: routes.app.dashboard }));
    }
  }
}

const configuration = {
  name: 'authenticate',
  action: actions,
  sagas: authenticate,
  reducers: {
    reducer: (state, { payload: { idToken, mockUserId } }) => ({
      ...state,
      isLoggingIn: false,
      isLoggingOut: false,
      isAuthenticated: true,
      userId: fp.flow(
        jwtDecode,
        fp.getOr(null)('sub')
      )(idToken),
      idToken: idToken,
      mockUserId: mockUserId,
      message: null
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/session/configurations/authenticate.js